import CustomChip from "./CustomChip";

type PaymentBouttonProps = {
    onClick?: Function;
    isPayed?: boolean;
    disabled?: boolean;
};

export default function PaymentBoutton({
    onClick,
    isPayed = false,
    disabled = false,
}: PaymentBouttonProps) {
    const borderColor = `${isPayed ? "#3BD838" : "#C8CDD0"}`;
    return (
        <CustomChip
            disabled={disabled}
            onClick={async () => {
                if (onClick) {
                    await onClick();
                }
            }}
            sx={{
                display: "flex",
                height: "1.5rem",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "1.25rem",
                border: `1x solid ${borderColor}`,
                background: `${isPayed ? "#D8F7D7" : "#F3F5F6"}`,
                borderColor: `${borderColor}`,
                ".MuiChip-label": {
                    color: "#023",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "0.75rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                },
            }}
            label={isPayed ? "Payé" : "Non payé"}
        />
    );
}
